/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const QuizScoreDto = {
    Low: 'LOW',
    Average: 'AVERAGE',
    Good: 'GOOD',
    VeryGood: 'VERY_GOOD',
    Outstanding: 'OUTSTANDING'
} as const;

export type QuizScoreDto = typeof QuizScoreDto[keyof typeof QuizScoreDto];



